<template>
  <div>
    <b-modal
      centered
      size="md"
      no-close-on-esc
      no-close-on-backdrop
      v-model="modalVisivel"
      @hidden="onModalClose"
      :hide-footer="isGerandoRelatorio"
      :hide-header-close="isGerandoRelatorio"
    >
      <template #modal-title>
        {{
          isGerandoRelatorio ? "Processando Dados" : "Transferência de Créditos"
        }}
      </template>

      <transition name="fade" mode="out-in">
        <div v-if="isGerandoRelatorio" class="text-center py-2">
          <div class="d-flex justify-content-center align-items-center mb-3">
            <b-spinner class="mb-2" variant="primary" />
          </div>
          <h5 class="font-weight-bold mb-3">{{ mensagemStatus }}</h5>

          <b-progress
            :max="100"
            class="mt-3"
            height="20px"
            variant="success"
            :value="progresso"
            show-progress
          >
            <b-progress-bar
              :striped="progresso < 100"
              :animated="progresso < 100"
              :value="progresso"
              :label="progresso === 100 ? 'Concluído!' : `${progresso}%`"
            />
          </b-progress>
        </div>

        <div v-else>
          <div class="row d-flex">
            <div class="mb-1">
              <SelectCooperado
                :state="stateCooperado"
                v-model="selecaoCooperado"
              />
            </div>
            <div class="mt-1">
              <SelectSafra :state="stateSafra" v-model="selecaoSafra" />
            </div>
          </div>
        </div>
      </transition>

      <template v-slot:modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-end gap-2">
          <b-button
            variant="success"
            @click="consultar"
            :disabled="!podeGerarRelatorio"
          >
            <i class="fas fa-download me-1"></i>
            <span>Gerar Relatório</span>
          </b-button>

          <b-button
            class="button-fechar-modal"
            v-if="!isGerandoRelatorio"
            variant="secondary"
            @click="fecharModal"
          >
            <i class="mdi mdi-close me-1"></i>
            <span>Fechar</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script lang="js">
import SelectSafra from "../inputs/SelectSafra.vue";
import SelectCooperado from '../inputs/SelectCooperado.vue';
import { TransferenciaService } from '../../../../../services/astec/Transferencia';

export default {
  name: "RelatorioTransferenciaCreditos",
  components: {
    SelectSafra,
    SelectCooperado,
  },
  props: {
    isOpenModal: {
      type: Boolean,
      default: false
    },
    filtrosDeProjetos: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      progresso: 0,
      selecaoSafra: null,
      validaState: false,
      modalVisivel: false,
      selecaoCooperado: null,
      progressInterval: null,
      isGerandoRelatorio: false,
      jaCarregouDoVuexNestaSessao: false,
      mensagemStatus: "Por favor, aguarde enquanto geramos seu relatório..",
    };
  },

  watch: {
    isOpenModal(valorModal) {
      if (valorModal) {
        this.modalVisivel = valorModal;
        if (!this.jaCarregouDoVuexNestaSessao) {
          this.carregarFiltrosDoVuex();
          this.jaCarregouDoVuexNestaSessao = true;
        } else {
          this.limparSelecoes();
        }
      }
    },
  },

  computed: {
    stateCooperado() {
      if (this.selecaoCooperado) return true;
      if (this.validaState) return false;
      return null;
    },

    stateSafra() {
      if (this.selecaoSafra) return true;
      if (this.validaState) return false;
      return null;
    },

    filtrosRecebidos() {
      const filtros = {};

      Object.keys(this.filtrosDeProjetos).forEach(key => {
        const valor = this.filtrosDeProjetos[key];
        if (valor !== null && valor !== undefined && valor !== '') {
          if (typeof valor === 'object') {
            if (Object.keys(valor).length > 0) {
              filtros[key] = valor;
            }
          } else {
            filtros[key] = valor;
          }
        }
      });

      return filtros;
    },

    temFiltrosRecebidos() {
      return Object.keys(this.filtrosRecebidos).length > 0;
    },

    podeGerarRelatorio() {
      const hasSafra = this.selecaoSafra !== null;
      const hasCooperado = this.selecaoCooperado !== null;

      return hasSafra && hasCooperado;
    },
  },

  methods: {
    carregarFiltrosDoVuex() {
      this.limparSelecoes();

      if (this.filtrosRecebidos.cooperado) {
        this.selecaoCooperado = this.filtrosRecebidos.cooperado;
      }

      if (this.filtrosRecebidos.safra) {
        this.selecaoSafra = this.filtrosRecebidos.safra;
      }
    },

    consultar() {
      const dados = {
        safra: this.selecaoSafra.name || null,
        cooperado: this.selecaoCooperado?.value || null,
      };

      const dadosFiltrados = Object.fromEntries(
        Object.entries(dados).filter(([, value]) => value != null)
      );

      this.processarRelatorio(dadosFiltrados);
    },

    iniciarProgressoFake() {
      this.progresso = 0;

      this.progressInterval = setInterval(() => {
        if (this.progresso < 30) {
          this.progresso += 4;
        } else if (this.progresso < 70) {
          this.progresso += 2;
        } else if (this.progresso < 92) {
          this.progresso += 0.5;
        }

        if (this.progresso < 40) {
          this.mensagemStatus = "Coletando dados...";
        } else if (this.progresso < 75) {
          this.mensagemStatus = "Processando informações...";
        } else {
          this.mensagemStatus = "Gerando PDF...";
        }
      }, 250);
    },

    async processarRelatorio(dados) {
      this.isGerandoRelatorio = true;
      this.mensagemStatus = "Gerando relatório...";
      this.iniciarProgressoFake();

      const inicio = Date.now();
      let pdfUrl = null;

      try {
        const dadosParaAPI = {
          cdCooperado: dados.cooperado || null,
          safra: dados.safra || null,
        };

        const response =
          await TransferenciaService.gerarRelatorioTransferencia(dadosParaAPI);

        const tempoMinimo = 2000;
        const decorrido = Date.now() - inicio;
        if (decorrido < tempoMinimo) {
          await this.delay(tempoMinimo - decorrido);
        }

        clearInterval(this.progressInterval);
        this.progresso = 95;
        this.mensagemStatus = "Finalizando PDF...";

        const pdfBlob = new Blob([response], { type: "application/pdf" });
        pdfUrl = URL.createObjectURL(pdfBlob);

        window.open(pdfUrl, "_blank");

        this.progresso = 100;
        this.mensagemStatus = "Concluído!";

        setTimeout(() => {
          this.$tools.alerta("Relatório gerado com sucesso!", "success");
          this.isGerandoRelatorio = false;
          this.modalVisivel = false;
          this.progresso = 0;
          this.limparSelecoes();
          this.$emit("fechar");
        }, 1500);

      } catch (error) {
        console.error("Erro ao gerar PDF de Transferência:", error);

        let mensagemErro =
          "Erro ao gerar relatório de transferências.";
        if (error.response && error.response.status === 404) {
          mensagemErro =
            "Nenhum dado de transferência encontrado para os filtros selecionados.";
        }

        this.$tools.alerta(mensagemErro, "error");
        this.isGerandoRelatorio = false;

      } finally {
       clearInterval(this.progressInterval);

        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }

        this.mensagemStatus = "Por favor, aguarde enquanto geramos seu relatório...";
        this.limparSelecoes();
      }
    },

    delay(ms) {
      return new Promise((res) => setTimeout(res, ms));
    },

    limparSelecoes() {
      this.selecaoSafra = null;
      this.selecaoCooperado = null;
      this.validaState = false;
    },

    fecharModal() {
      this.modalVisivel = false;
      this.$emit("fechar");
    },

    onModalClose() {
      if (this.progressInterval) clearInterval(this.progressInterval);
      this.isGerandoRelatorio = false;
      this.progresso = 0;
      this.mensagemStatus = "Por favor, aguarde enquanto geramos seu relatório..";
      this.$emit("fechar");
      this.limparSelecoes();
    },
  },
};
</script>

<style lang="css" scoped>
.button-fechar-modal {
  width: 140px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
